import shared from 'emun.order/_labels.es6';

export default Object.assign(shared, {
    lineNote: "",
    expectedToClear: "Export Date",
    shareWith: "Share With",
    priceList: "Price List"
});
